const readingValueFormatter = new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 });

/** A reading for the legend, the hover tags and the y-axis fallback: at most 2 decimals, no float noise. */
export function formatReadingValue(value: number): string {
    return readingValueFormatter.format(value);
}

const clockFormatter = new Intl.DateTimeFormat("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
const dayFormatter = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric" });

/** "2:00" and "pm", apart, for a span that names the period once. */
export function clockParts(ms: number): [time: string, period: string] {
    // Newer ICU puts a narrow no-break space before the period.
    const [time = "", period = ""] = clockFormatter.format(ms).split(/\s/);
    return [time, period.toLowerCase()];
}

/** "2:00 pm". */
export function formatClockTime(ms: number): string {
    const [time, period] = clockParts(ms);
    return `${time} ${period}`;
}

/** "Oct 13, 2:00 pm". */
export function formatDayTime(ms: number): string {
    return `${dayFormatter.format(ms)}, ${formatClockTime(ms)}`;
}

export function isSameLocalDay(aMs: number, bMs: number): boolean {
    return new Date(aMs).toDateString() === new Date(bMs).toDateString();
}
